import { lazy } from 'react'
import yn from 'yn'

const fallback = null
const env = process.env

const features = Object.freeze({
  RedirectCustomConexxeFeature: yn(
    env.REACT_APP_CONEXXE_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectConexxe/RedirectConexxe'))
    : fallback,
  RedirectCustomZendeskFeature: yn(
    env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectZendesk'))
    : fallback,
  RedirectCustomContactZendeskFeature: yn(
    env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectContactZendesk'))
    : fallback,
  ZendeskWebWidget: yn(env.REACT_APP_HAS_ZENDESK_WEBWIDGET)
    ? lazy(() => import('Widgets/Zendesk'))
    : fallback,
  CupomFeature: yn(env.REACT_APP_COUPON_DISCOUNT)
    ? lazy(() => import('features/Checkout/Summary/Coupon/Coupon'))
    : fallback
})

export default features



// WEBPACK FOOTER //
// ./src/features/ToggleFeature/Features.js